import React from "react";
import { useParams, Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentFailed() {
  const { invoiceId } = useParams<{ invoiceId: string }>();

  return (
    <div className="max-w-xl mx-auto p-6 text-center space-y-6">
      <XCircle className="w-16 h-16 text-red-600 mx-auto" />
      <h1 className="text-2xl font-bold">Payment Failed</h1>
      <p className="text-gray-500">
        Something went wrong with your payment. Please try again.
      </p>
      <Link
        to={`/invoice/${invoiceId}`}
        className="bg-black text-white px-6 py-3 rounded-xl inline-block font-semibold"
      >
        Retry Payment
      </Link>
      <Link
        to="/my-invoices"
        className="text-blue-600 hover:underline block mt-2"
      >
        Back to Invoices
      </Link>
    </div>
  );
}
